// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nm-1";
export var messageSideRight = "_nm-2";
export var subscribeToBackInStockBubbleContainer = "_nm-0";